import gql from 'graphql-tag';

export const DEVOLVEREMPLEADOS = gql`
  query devolverEmpleados($ids:[String]){
    devolverEmpleados(ids:$ids){
      id
      nombre
      cargo{
        id
        cargo
      }
    }
  }
`;

export const DEVOLVEREMPLEADOSSEMTIENDA = gql`
  query devolverEmpleadosSemTienda($semana:String, $tienda:String){
    devolverEmpleadosSemTienda(semana:$semana, tienda:$tienda){
      id
      nombre
      cargo{
        id
        cargo
      }
    }
  }
`;

